import Adicionar from './Adicionar';
import Default from './Default';
import Editar from './Editar';

const CategoriasDefault = Default;

export default CategoriasDefault;
export const CategoriasAdicionar = Adicionar;
export const CategoriasEditar = Editar;
